import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const AuthContext = createContext(null);

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const API = `${BACKEND_URL}/api`;

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = async () => {
    const storedToken = localStorage.getItem("sigmacare_token");
    const hasSessionCookie = typeof document !== "undefined" && document.cookie.includes("access_token=");
    if (!storedToken && !hasSessionCookie) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const headers = storedToken ? { Authorization: `Bearer ${storedToken}` } : {};
      const res = await axios.get(`${API}/auth/me`, { withCredentials: true, headers });
      if (res.data) setUser(res.data);
    } catch (err) {
      localStorage.removeItem("sigmacare_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkAuth();
  }, []);

  const logout = async () => {
    try {
      await axios.post(`${API}/auth/session/logout`, {}, { withCredentials: true });
    } catch (e) {
      // ignore
    } finally {
      localStorage.removeItem("sigmacare_token");
      setUser(null);
    }
  };

  const setSessionUser = (data) => {
    if (data?.token) localStorage.setItem("sigmacare_token", data.token);
    const { token, message, ...u } = data || {};
    setUser(u);
    checkAuth();
  };

  const openAuth = (role = "patient") => {
    window.location.assign(role === "admin" || role === "staff" ? "/admin/login" : `/login`);
  };

  return (
    <AuthContext.Provider value={{ user, loading, logout, openAuth, setSessionUser, refreshUser: checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
